import React from "react";

import "./AboutPage.style.scss";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

import headshot from "../assets/glitchy_frog.jpg";
import sky from "../assets/sky.jpg";

export default function AboutPage() {
  return (
    <>
      <NavBar />
      <div className='about-page'>
        <div className='img-grid'>
          <img alt='me' src={headshot} className='me' style={{ borderRadius: '10%' }} />
          <img alt='sky' src={sky} className='sky' />
        </div>

        <div className='about-grid two-column'>
          <div className='column left'>
            <h1>About Me</h1>
            <h2>
              I’m Justin — a software engineer who loves building things that actually work in the real world. I’ve spent the last few years deep in backend systems, distributed services, and full‑stack apps. What keeps me hooked is simple: solving problems that matter and shipping with purpose.
            </h2>

            <h2>
              I’m the kind of person who learns by doing. Most of my growth came from taking ownership of messy systems, understanding how things break, and rebuilding them into something cleaner and more reliable. I care about the craft of engineering — not just the code.
            </h2>

            <h2>
              Outside of work, I'm usually exploring new tools, diving into tech rabbit holes, or building small side projects just because they're fun.
            </h2>
          </div>

          <div className='column right'>
            <h3>Tech Stack</h3>
            <ul>
              <li>Golang</li>
              <li>Typescript</li>
              <li>React / Next.js</li>
              <li>PostgreSQL</li>
              <li>Docker & CI/CD</li>
              <li>CosmosSDK</li>
            </ul>

            <h3>What I Like Working On</h3>
            <ul>
              <li>Backend systems & distributed services</li>
              <li>APIs, data pipelines, and monitoring</li>
              <li>Developer tools & polished UI/UX</li>
            </ul>

            <h3>Personal</h3>
            <ul>
              <li>I love collaborating with people who push me to level up</li>
              <li>I stay curious — new tech, new ideas, new problems</li>
              <li>Always tinkering with small side projects</li>
              <li>Big fan of clean interfaces, simple solutions, and good coffee</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
